<div class="flex items-center justify-start !gap-3">
  <button
    type="button"
    class="relative inline-flex !h-6 !w-11 flex-shrink-0 cursor-pointer rounded-full !border-2 !border-solid border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-feedback-success-medium focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
    [ngClass]="value ? 'bg-feedback-success-medium' : 'bg-neutral-hight-medium'"
    role="switch"
    [attr.aria-checked]="value"
    [disabled]="disabled"
    (click)="onInputChange($event)"
  >
    <span class="sr-only">{{ label }} status</span>

    <span
      class="pointer-events-none relative inline-block !h-5 !w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
      [ngClass]="value ? 'translate-x-5' : 'translate-x-0'"
    >
      <span
        class="absolute !inset-0 flex h-full w-full items-center justify-center transition-opacity duration-200 ease-in"
        [ngClass]="
          value
            ? 'opacity-0 duration-100 ease-out'
            : 'opacity-100 duration-200 ease-in'
        "
        aria-hidden="true"
      >
        @if (showIcon) {
          <svg
            class="!h-3 !w-3 text-neutral-hight-dark"
            fill="none"
            viewBox="0 0 12 12"
          >
            <path
              d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        }
      </span>
      <span
        class="absolute inset-0 flex h-full w-full items-center justify-center text-feedback-success-medium transition-opacity duration-100 ease-out"
        [ngClass]="
          value
            ? 'opacity-100 duration-200 ease-in'
            : 'opacity-0 duration-100 ease-out'
        "
        aria-hidden="true"
      >
        @if (showIcon) {
          <svg
            class="!h-3 !w-3 text-current"
            fill="currentColor"
            viewBox="0 0 12 12"
          >
            <path
              d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z"
            />
          </svg>
        }
      </span>
    </span>
  </button>

  @if (label) {
    <div class="!ml-2">
      <span class="text-sm font-medium text-neutral-low-dark">{{ label }}</span>
      @if (description) {
        <span class="text-text-neutral-low-medium !ml-1 text-sm"
          >({{ description }})</span
        >
      }
    </div>
  }
</div>
